import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-omni-app-icon',
  templateUrl: './omni-app-icon.component.html',
  styleUrls: ['./omni-app-icon.component.scss'],
  standalone: false,
})
export class OmniAppIconComponent implements OnInit, OnChanges {
  @Input()
  icons: { [key: string]: string };
  @Input()
  appId: string;

  iconUrl: string;
  iconColor: string;

  ngOnInit(): void {
    this.iconUrl = this.icons[this.appId];
    this.iconColor = getIconColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.icons) {
      this.iconUrl = this.icons[this.appId];
    }
  }
}

function getIconColor(): string {
  const COLOR_CODES = [
    '#EF5350',
    '#42A5F5',
    '#66BB6A',
    '#FFA726',
    '#AB47BC',
    '#FFCA28',
    '#EC407A',
    '#26C6DA',
    '#FF7B57',
  ];

  // Choose randomly from the list of color codes
  return COLOR_CODES[Math.floor(Math.random() * Math.floor(COLOR_CODES.length))];
}
